// Module
var code = `{{#listItems}}
<li class="deck-bullet deck-bullet--{{attrBulletType}}">
  <span class="deck-bullet-glyph" aria-hidden="true"></span>
  <span class="deck-bullet-copy">{{copy}}</span>
</li>
{{/listItems}}
`;
// Exports
module.exports = code;